import React from 'react'
import PropTypes from 'prop-types'
import { compose, withProps } from 'recompose'
import Topic from '../common/Topic'
import { withRouter } from 'react-router'

export const TopicPage = ({ systemName }) => <Topic systemName={systemName} />

TopicPage.propTypes = {
  location: PropTypes.object,
  systemName: PropTypes.string,
}

const enhance = compose(
  withRouter,
  withProps((o) => ({
    systemName: o.match.params.systemName,
  })),
)

export default enhance(TopicPage)
